import { render } from "./EditorCreateModal.vue?vue&type=template&id=3506cc14&scoped=true"
import script from "./EditorCreateModal.vue?vue&type=script&lang=js"
export * from "./EditorCreateModal.vue?vue&type=script&lang=js"

import "./EditorCreateModal.vue?vue&type=style&index=0&id=3506cc14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3506cc14"]])

export default __exports__